import { render, staticRenderFns } from "./TableBoxOrder.vue?vue&type=template&id=fdf65a78&scoped=true"
import script from "./TableBoxOrder.vue?vue&type=script&lang=js"
export * from "./TableBoxOrder.vue?vue&type=script&lang=js"
import style0 from "./TableBoxOrder.vue?vue&type=style&index=0&id=fdf65a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf65a78",
  null
  
)

export default component.exports